import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { CheckinPassengerAdditionResultModel } from './checkin-passenger-addition-result.state';

/** StateDetailsActions */
const ACTION_SET = '[CheckinPassengerAdditionResult] set';
const ACTION_UPDATE = '[CheckinPassengerAdditionResult] update';
const ACTION_RESET = '[CheckinPassengerAdditionResult] reset';
const ACTION_FAIL = '[CheckinPassengerAdditionResult] fail';
const ACTION_CANCEL_REQUEST = '[CheckinPassengerAdditionResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CheckinPassengerAdditionResult] set from api';
const ACTION_UPDATE_FROM_API = '[CheckinPassengerAdditionResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCheckinPassengerAdditionResult = createAction(
  ACTION_SET,
  props<WithRequestId<CheckinPassengerAdditionResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCheckinPassengerAdditionResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<CheckinPassengerAdditionResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinPassengerAdditionResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCheckinPassengerAdditionResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCheckinPassengerAdditionResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCheckinPassengerAdditionResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<CheckinPassengerAdditionResultModel>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCheckinPassengerAdditionResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<CheckinPassengerAdditionResultModel>>()
);
